export default __webpack_public_path__ + "9c6749a5b55093a2aa3de9efd0bbbd0e.woff";